import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchStatesUrl = CONSTANT.baseUrl + ENDPOINTS.employee.state.fetchStates;
const fetchStateUrl = CONSTANT.baseUrl + ENDPOINTS.employee.state.fetchState;
const addNewStateUrl = CONSTANT.baseUrl + ENDPOINTS.employee.state.addNewState;

export const actionType = {
    REQUESTED_STATE_DATA: 'REQUESTED_STATE_DATA',
    REJECTED_STATE_DATA: 'REJECTED_STATE_DATA',
    FETCH_STATES: 'FETCH_STATES',
    FETCH_STATE: 'FETCH_STATE',
    EDIT_STATE: 'EDIT_STATE',
    UPDATE_STATE_SELECTED: 'UPDATE_STATE_SELECTED',
    UPDATE_EDIT_STATE_PAYLOAD: 'UPDATE_EDIT_STATE_PAYLOAD'
};

export const fetchStates = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_STATE_DATA
        });

        return generalHttpGetRequest(fetchStatesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_STATES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_STATE_DATA,
                    data: error
                });
            });
    };
};

export const fetchState = stateId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_STATE_DATA
        });

        return generalHttpGetRequest(fetchStateUrl + stateId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_STATE,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_STATE_DATA,
                    data: error
                });
            });
    };
};

export const editState = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_STATE_DATA
        });

        return generalHttpPutRequest(addNewStateUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.EDIT_STATE,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_STATE_DATA,
                    data: error
                });
                return error;
            });
    };
};


export const updateStateSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_STATE_SELECTED,
            payload: selected
        });
    };
};

export const updateEditStatePayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_STATE_PAYLOAD,
            payload: selected
        });
    };
};


// WEBPACK FOOTER //
// ./src/services/redux/employee/state/actions.js